import React, { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'

import {downloadFile, projectContext, loadingContext, intentsContext, urlValue, unfolder, onImportExcelAsync, openAlert } from '../lib'
import SideBar from '../components/SideBar'
import { customModal } from '../styles/customModal'
import TitleBar from "../components/TitleBar";
import CheckBox2 from '../components/CheckBox2'
import Loading from '../components/Loading'
import BoxInfo from '../components/common/BoxInfo'
import { Tooltip } from 'react-tooltip'
import { NewVoice } from '../components/NewVoice'

import '../styles/voiceCRUD.scss'
import '../styles/voice.scss'

export default function Voices() {
  const [isModalOpen, setIsModalOpen] = useState({ delete: false, code: false })
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [selectedVoice, setSelectedVoice] = useState({})
  const [sidePanel, setSidePanel] = useState('detail')
  const [refresh, setRefresh] = useState(0)
  const ref = useRef(null)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useContext(loadingContext)
  const [loadingUpload, setLoadingUpload] = useState(false)
  const [sort, setSort] = useState('asc')
  const [voicesDelete, setVoicesDelete] = useState([]);
  const [modalDelete, setModalDelete] = useState(false);
  const [listVoices, setListVoices] = useState([]);

  // const listVoices = [{name: "aVoice1"}, {name: "voice4"}, {name: "Voice3"}, {name: "Voice2"}, {name: "zVoice1"}]

  useEffect(() => {
    getAllVoices();
  }, [refresh])

  const getAllVoices = () => {
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/voice`,
      headers: {
        'access-token': token,
        'Content-Type': 'application/json',
      },
    })
      .then(function (response) {
        setListVoices(response?.data || [])
        setLoading(false)

      })
      .catch(function (error) {
        console.log(error)
        setLoading(false)
      })
  }

  function handleVoice(voice) {
    setSidePanel('edit')
    // intentsCtx.updateState(answer, "answerSelected");
    setSelectedVoice(voice)
  }

  function openModal(voice) {
    setIsModalOpen({ delete: true, code: false })
    setSelectedVoice(voice)
    
  }

  const sortElementsChange = (e) => {
    setSort(e.target.value);
  }

  const sortElements = () => {
    let sortOrder = sort;
    let result;
    
    switch (sortOrder) {
      case 'asc':
        result = (a, b) => a.name?.toLowerCase() > b.name?.toLowerCase() ? 1 : -1;
        break;
      case 'desc':
        result = (a, b) => a.name?.toLowerCase() < b.name?.toLowerCase() ? 1 : -1;
        break;
    }

    return result;
  }

  const deleteAnswer = () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
      
    setLoading(true)  
    axios({
      method: 'delete',
      url: `${urlValue}/studio/voice/${selectedVoice.id}`,
      headers: {
        'user': id,
        'access-token': token,
        'Content-Type': 'application/json',
      }
    })
    .then(function (response) {

      setSidePanel('')
      setSelectedVoice({})

      setRefresh(refresh + 1)
      setIsModalOpen({ delete: false, code: false })
      setTimeout(() => {
        getAllVoices("all")
      }, 3000)
    })
    .catch(function (error) {
      console.log(error)

      setIsModalOpen({ delete: false, code: false })
      setTimeout(() => {
        getAllVoices("all")
      }, 3000)
    })
  }

  const selectForDelete = (e, item) => {
    if (e.target.checked) {
      setVoicesDelete([...voicesDelete, item])
    } else {
      setVoicesDelete(voicesDelete.filter(x => x.id !== item.id));
    }
  }

  const selectAll = (e) => {
    if (e.target.checked) {
      document.querySelectorAll("#intent-all input[type='checkbox']").forEach((item) => {
        item.checked = true;
      })
    } else {
      document.querySelectorAll("#intent-all input[type='checkbox']").forEach((item) => {
        item.checked = false;
      })
    }
  }

  const deleteMultiple = () => {
    console.log("Detele")
  }
  
  return (
    <div>
      <section className="container-voices general-container" id="container">
        {/* <SideBar active={'Voices'} /> */}
        <div className="row_primary">
          <div className="con_title_bar">
            <TitleBar />
          </div>
          <div className="con_header">
            <div className="header">
              <div className="title">
                <div className="voices">
                  <div className="project-name-container">
                    <div className="icon"></div>
                    <h2>{selectedProject.name}</h2>
                  </div>
                  <div className="separator">-</div>
                  <div>
                    <h1>Customizable Voices</h1>
                  </div>

                </div>

                <div className="head justify-end flex-1">
                <div className="flex items-center justify-end flex-wrap">
                    <BoxInfo
                      id="uploadexc-tp"
                      titleClass='mr-0-1 color-label f-16  title-intent'
                      title=""
                      place="top"
                      containerClass='mr-0-1 z-15 '
                      render={`<div> With this option, you can upload audios for create the voice  </div>`}
                    />
                    <div className="upload-excel btn-excel upload-btn trans">

                      {loadingUpload ? <Loading /> : <>
                        <img src="/icons/audio-icon.svg" alt="newAns" style={{ width: 19 }} />
                        <label> Upload Audios</label>

                      </>}

                      <input type='file' accept='.xlsx, .xls'  />
                    </div>
                  </div>
                  <button id='newbtn-tp' className="newProject  btn-top btn-top-new " style={{ marginLeft: 6, }} onClick={() => {setSidePanel('new'); setSelectedVoice(null)}}>
                    {/* <img src="/icons/new.png" alt="newAns" /> */}
                    <span>New Voice</span>
                    <Tooltip anchorSelect="#newbtn-tp" content={`Create a new Voice`} place="top" />
                  </button>
                  <button id='delete-tp' className="newProject btn-top btn-top-new" style={{ marginLeft: 6 }} onClick={() => setModalDelete(true)}>
                    <span>Delete</span>
                    <Tooltip anchorSelect="#delete-tp" content={`Delete one or multiple Voices`} place="top" />
                  </button>


                </div>
              </div>

            </div>
            <div className="container-info">

              <div className="body-container">
                <div className="body left-c " id="intent-all">
                  <div className="flex flex-row items-center pb-2 ml-2">
                    <div className="search-iva input-search">
                      <input
                        type="text"
                        placeholder="Search Voice"
                        onChange={event => {
                          setSearch(event.target.value)
                        }}
                      />
                      <img src="/icons/search.svg" alt="" />
                    </div>
                    <div className="flex-1 d-flex flex-row  items-center justify-end ">
                      <label htmlFor="sort" className='title-search'>Organize:</label>
                      <select onChange={sortElementsChange} name="" id="sort" className="  input-search select-nesting"
                        style={{ border: '1px solid gray', borderRadius: 20, padding: "0px 7px 0 9px", marginLeft: 8, minWidth: 100, height: 35, fontSize: 18, backgroundPositionX: "80%" }}>
                        <option value="asc" selected>ASC</option>
                        <option value="desc">DESC</option>
                      </select>
                    </div>
                  </div>

                  <div className="elements sm3-h-80vh scroll-panel-left" ref={ref}>
                    {listVoices.length > 0 &&
                      <div className='rounded-md flex items-center' style={{ marginLeft: 20, marginRight: 20, paddingLeft: 15 }}>
                        <CheckBox2 onChange={(e) => selectAll(e)} default={false} id={`ck-all-proj`} text="" />
                        <labe><b></b>Select all Voice</labe>
                      </div>}
                    {listVoices
                      .filter(value => {
                        if (search == '') {
                          return value
                        } else if (
                          value.name.toLowerCase().includes(search.toLowerCase())
                        ) {
                          return value
                        }
                      })
                      .sort(sortElements())
                      .map((voice, index) => (
                        <div className="element" key={index}>
                          <div className="answer">
                            <CheckBox2 onChange={(e) => selectForDelete(e, voice)} default={false} id={`${voice.name}`} text="" />
                            <div className='list-color' >{voice.name}</div>
                          </div>
                          <div className="options_container">
                            <img
                              id={`delete-tp-${index}`}
                              src="/icons/trash.png"
                              alt="trash"
                              onClick={() => openModal(voice)}
                            />
                            <Tooltip anchorSelect={`#delete-tp-${index}`} content={`Delete`} place="top" />
                            <div id={`Setting-tp-${index}`} className="more" onClick={() => handleVoice(voice)}>
                              <div style={{ color: "#707070" }} >Setting</div>
                              <img src="/icons/Expand_left.svg" alt="expandLeft" />
                            </div>
                            <Tooltip anchorSelect={`#Setting-tp-${index}`} content={`Go to voice settings`} place="top" />
                          </div>

                        </div>
                      ))}
                  </div>
                  
                </div>

                <div className="container-edit right-c scroll-panel-rigth-intents">

                {sidePanel == 'edit' ? (
                    <NewVoice
                    selectedVoice = {selectedVoice}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    update={() => { getAllVoices() }}
                    />
                  ) : sidePanel == 'new' ? (
                    <NewVoice
                    selectedVoice = {selectedVoice}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    update={() => { getAllVoices() }}
                    />
                  ) : null
                }


                </div>


              </div>

            </div>
          </div>
        </div>

      </section>
      <Modal isOpen={isModalOpen.delete} style={customModal} ariaHideApp={false}>
        <div id="container-modal" className='modal-c'>
          <img src="/icons/alert.png" />
          <h1>You are about to delete a voice.</h1>
          <h1>Are you sure you want to proceed?</h1>
          <div className="buttons-modal">
            <button
              onClick={() => setIsModalOpen({ delete: false, code: false })}
              className="cancel btn-modal-cancel"
            >
              Cancel
            </button>
            <button onClick={deleteAnswer} className="accept">
              Accept
            </button>
          </div>
        </div>
      </Modal>

      <Modal isOpen={modalDelete} style={customModal} ariaHideApp={false}>
        <div id="container-modal" className='modal-c'>
          <img src="/icons/alert.png" alt='' />
          <h1>You are about to delete voices.</h1>
          <h1>Are you sure you want to proceed?</h1>
          <div className="buttons-modal">
            <button
              onClick={() => setModalDelete(false)}
              className="cancel btn-modal-cancel"
            >
              Cancel
            </button>
            <button onClick={() => { deleteMultiple() }} className="accept">
              Accept
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}
